import { apiClient, API_PRX } from '@indipia/shared';

export interface UpcomingAgent {
  agentId: number;
  agentName: string;
  agentDescription: string;
  expectedAt: string | null;
  notifySubscribed: boolean;
}

export interface NotifyResult {
  agentId: number;
  notifySubscribed: boolean;
}

export async function fetchUpcomingAgents(): Promise<UpcomingAgent[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/agents/upcoming`);
  return (res.data.data ?? []) as UpcomingAgent[];
}

export async function subscribeAgentNotify(agentId: number): Promise<NotifyResult> {
  const res = await apiClient.post(`${API_PRX.INDIPIA}/agents/${agentId}/notify`);
  return res.data.data as NotifyResult;
}

export async function fetchAgentGuide(agentId: number): Promise<string> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/agents/guide/${agentId}`);
  return (res.data.data?.agentGuide ?? '') as string;
}
